(() => {
  const positionStartDesigningButton = (root = document) => {
    root.querySelectorAll('.custom-main-product .product__info-container').forEach((container) => {
      const quantityRow = container.querySelector('.qty_submitWrap');
      const wrapper = container.querySelector('.buy_btnWrap');

      if (quantityRow && wrapper && wrapper.parentElement !== quantityRow) {
        quantityRow.append(wrapper);
      }

      if (!wrapper) return;

      const button = wrapper.querySelector('.start-designing-button');
      const buttonRow = wrapper.querySelector('.product-form__buttons');

      if (button && buttonRow && button.parentElement !== buttonRow) {
        buttonRow.append(button);
      }
    });
  };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', () => positionStartDesigningButton());
  } else {
    positionStartDesigningButton();
  }

  document.addEventListener('shopify:section:load', (event) => positionStartDesigningButton(event.target));
})();
